<template>
        <div id="app">

            <el-container style="padding-top: 60px">

                <el-header class="header-all">
                    <div class="menu-header-log" style="display: flex;margin: 0 auto;justify-content: space-between;">

                        <div class="menu-header-title-phone">
                            <div class="header-icon" @click="drawer=true">
                                <i class="el-icon-s-fold drawer-edit"></i>
                            </div>
                            <el-drawer
                                    :visible.sync="drawer"
                                    :size="'200px'"
                                    :append-to-body="true"
                                    :direction="direction">
                                <el-menu
                                        :default-active="defaultActive"
                                        class="el-menu-demo header-menu"
                                        mode="vertical"
                                        @select="handleSelect"
                                        style="background: transparent"
                                        :router="router"
                                        menu-trigger="hover"
                                        text-color="#999999"
                                        active-text-color="#005DAB"
                                >
                                    <el-menu-item index="/">首页</el-menu-item>
                                    
                                    <el-submenu index="/product">
                                        <template slot="title"> 产品技术</template>
                                        <el-menu-item index="/product/robot">巡检机器人</el-menu-item>
                                        <el-menu-item index="/product/belt">输送带撕裂检测装置</el-menu-item>
                                        <el-menu-item index="/product/sensor">传感器</el-menu-item>
                                    </el-submenu>
                                    <el-menu-item index="/solution">解决方案</el-menu-item>
                                    <el-menu-item index="/company/news">新闻热点</el-menu-item>
                                    <el-submenu index="/about">
                                        <template slot="title"> 关于mk体育</template>
                                        <el-menu-item index="/about/company">公司简介</el-menu-item>
                                        <el-menu-item index="/about/consultation">合作咨询</el-menu-item>
                                    </el-submenu>
                                </el-menu>
                            </el-drawer>
                        </div>
                        <div class="logo">

                            <img src="./assets/img/toplogo.svg" width="218" height="31" alt/>
                        </div>
                        <div class="menu-header-title">
                            <el-menu
                                    :default-active="defaultActive"
                                    class="el-menu-demo header-menu"
                                    mode="horizontal"
                                    @select="handleSelect"
                                    style="background: transparent"
                                    :router="router"
                                    menu-trigger="hover"
                                    text-color="#999999"
                                    active-text-color="#005DAB"
                            >
                                <el-menu-item index="/">首页</el-menu-item>
                                
                                <el-submenu index="/product">
                                    <template slot="title"> 产品技术</template>
                                    <el-menu-item index="/product/robot">巡检机器人</el-menu-item>
                                    <el-menu-item index="/product/belt">输送带撕裂检测装置</el-menu-item>
                                    <el-menu-item index="/product/sensor">传感器</el-menu-item>

                                    
                                </el-submenu>
                                <el-menu-item index="/solution">解决方案</el-menu-item>
                                <el-menu-item index="/company/news">新闻热点</el-menu-item>
                                <el-submenu index="/about">
                                    <template slot="title"> 关于mk体育</template>
                                    <el-menu-item index="/about/company">公司简介</el-menu-item>
                                    <el-menu-item index="/about/consultation">合作咨询</el-menu-item>
                                    <el-menu-item index="/about/recruitment">招聘信息</el-menu-item>
                                </el-submenu>
                            </el-menu>
                        </div>

                    </div>
                </el-header>
                <el-main>
                    <router-view/>
                </el-main>
                <div class="footer" v-show="isShow">
                    <div class="footer-content">
                        <div class="flex-1">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <img src="./assets/img/weixin.png" alt/>
                                    <div style="padding-left: 10px">微信公众号</div>
                                </el-col>
                                <el-col :span="8">
                                    <img src="./assets/img/weixin1.png" alt/>
                                    <div style="padding-left: 15px">合作咨询</div>
                                </el-col>
                                <el-col :xs="24" :sm="0">
                                    <div style="padding:10px;color: #B3B3B3;font-size: 14px">
                                        <div style="margin-bottom: 5px">联系方式：020-31704431</div>
                                        <div style="margin-bottom: 5px">广州总公司：广州市黄埔区联和大街玉树工业园J2栋402</div>
                                        <div >北京分公司：北京市海淀区西北旺地区黑龙潭路58号院1号绿地</div>
                                    </div>

                                </el-col>
                            </el-row>

                        </div>

                        <ul class="content-nav">
                            <li>
                                <p ></p>
                                <span>联系方式：020-31704431</span>
                                <span>广州总公司：广州市黄埔区联和大街玉树工业园J2栋402</span>
                                <span>北京分公司：北京市海淀区西三旗建材城东路18号（佰能大厦）</span>
                            </li>
                            <li>
                                <p >产品技术</p>
                                <router-link to="/product/robot"><span>巡检机器人</span></router-link>
                                <router-link to="/product/sensor"><span>传感器</span></router-link>
                                <router-link to="/product/belt"> <span>输送带撕裂检测装置</span></router-link>
                            </li>
                            <li>
                                <p >解决方案</p>
                                <router-link :to="{path:'/solution',query: {name: 'first'}}"><span>煤炭行业</span></router-link>
                                <router-link :to="{path:'/solution',query: {name: 'second'}}"> <span>电力行业</span></router-link>
                                <router-link :to="{path:'/solution',query: {name: 'third'}}"> <span>水泥行业</span></router-link>
                                <router-link :to="{path:'/solution',query: {name: 'fourth'}}"> <span>钢铁行业</span></router-link>
                                <router-link :to="{path:'/solution',query: {name: 'five'}}"> <span>港口行业</span></router-link>
                            </li>
                            <li>
                                <p >新闻热点</p>
                                <router-link to="/company/news"><span>公司新闻</span></router-link>

                            </li>
                            <li>
                                <p style="width: 152px">关于mk体育</p>
                                <router-link to="/about/company"><span>公司简介</span></router-link>
                                <router-link to="/about/consultation">     <span>合作咨询</span></router-link>
                            </li>
                        </ul>

                    </div>
                    <div class="copyright">
                        <span>京ICP备11017968号-1 Copyright 2026 mk体育(中国)官方网站 - mk sports 版权所有</span>
                    </div>
                </div>
            </el-container>
        </div>
</template>

<script>
    export default {
        data() {
            return {
                router: true,
                defaultActive: "",
                isShow: true,
                drawer:false,
                direction:"ltr",

            };
        },
        methods: {
            handleSelect(key) {
                //console.log(key)
            }
        },
        mounted() {
            this.defaultActive = location.href.split("#")[1]

        },
        updated() {
            this.defaultActive = location.href.split("#")[1]
        }
    };
</script>
<style lang="scss">
    * {
        padding: 0;
        margin: 0;
    }

    html,
    body {
        height: 100%;
    }

    #app {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #707070;
    }

    .header-menu {

      &.el-menu.el-menu--horizontal{
        border:none;
      }

        .el-menu-item,.el-submenu__title {
            height: 50px !important;
            line-height: 50px !important;
        }

        .el-menu-item:hover, .el-menu-item:focus, .el-menu-item:active {
            background: transparent !important;
        }
      .el-submenu__title:hover, .el-submenu__title:focus, .el-submenu__title:active {
        background: transparent !important;
      }
    }

    .el-header {
        display: flex;
        justify-content: space-between;
        align-content: center;
        width: 1240px;
        margin: 0 auto;
        background: white;
        //background-color: #fff;

        .logo {
            width: 280px;
            padding: 10px;
            line-height: 60px;

            img {
                width: 218px;
                height: 31px;
            }
        }
    }

    .el-main {
        padding: 0 !important;
    }

    .footer {
        width: 100%;
        overflow: hidden;
        background-color: #343434;
        margin-top: 30px;

        &-content {
            width: 1280px;
            margin: 0 auto;
            padding-top: 20px;
            display: flex;

            .flex-1 {
                flex: 1;
            }
            a{
                text-decoration: none;
                &:hover,&:active,&:focus{
                    text-decoration: none;

                    span{
                        color: white !important;
                    }
                }
            }
            .content-nav {
                display: flex;
                flex: 3;
                justify-content: space-around;

                li {
                    display: flex;
                    flex-direction: column;
                    padding: 0 20px;
                    //justify-content: center;
                    align-items: flex-start;

                    p {
                        font-size: 16px;
                        color: white;
                        padding: 10px 0;
                    }

                    span {
                        color: #B3B3B3;
                        font-weight: 300;
                        font-size: 12px;
                        padding: 5px 0;
                    }
                }
            }

            img {
                width: 80px;
                height: 80px;
                padding: 10px;
            }
        }

        .copyright {

            width: 1280px;
            margin: 20px auto;
            padding-left:10px;
            height: 70px;
            background: #343434;
            text-align: left;

            span {
                color: #B3B3B3;
                line-height: 30px;
                font-size: 12px;
            }
        }

    }

    .header-all {
        z-index: 100;
        background: white;
        box-shadow: 2px 2px 8px #DCDCDC;
        position: fixed;
        top: 0;
        width: 100%;
    }

</style>
